<template>
  <v-dialog
    v-model="dialog"
    persistent
    :content-class="isDarkMode ? 'dark-mode' : ''"
    :width="screenType === 'desktop' ? '500' : '300'"
  >
    <v-card class="bg-white dialog-content">
      <v-card-title
        class="text-h5 red white--text"
        :class="[isDarkMode && 'darken-3']"
      >
        {{ computedErrorTitle }}
        <v-spacer></v-spacer>
        <v-icon color="white" large>mdi-alert</v-icon>
      </v-card-title>

      <v-card-text
        class="fs-1-25r my-3 font-weight-regular"
        :aria-label="`Error, ${errorNotification}`"
        tabindex="0"
      >
        {{ computedErrorNotification }}
      </v-card-text>
      <div v-if="!isServerErrorCloseBtnHidden">
        <v-divider></v-divider>

        <v-card-actions class="ma-0 d-flex justify-end">
          <v-spacer></v-spacer>
          <Button
            :text="$t('Close')"
            btnType="grey"
            :clickAction="closeDialog"
          />
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import Button from '@/components/BaseComponents/Button/Button.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ServerErrorDialog',
  data() {
    return {
      dialog: true,
    }
  },
  props: {
    errorNotification: String,
    errorTitle: String,
    closeDialog: Function,
    screenType: String,
  },

  components: {
    Button,
  },

  computed: {
    ...mapGetters(['isDarkMode', 'isServerErrorCloseBtnHidden']),
    computedErrorTitle() {
      if (this.errorTitle) return this.$t(this.errorTitle)
      return this.$t('Error')
    },
    computedErrorNotification() {
      if (this.errorNotification === 'Username or password is incorrect')
        return this.$t('Username or password is incorrect')
      else if (this.errorNotification === 'Files were already deleted')
        return this.$t('Files were already deleted')

      return this.errorNotification
    },
  },
}
</script>
<style scoped>
  .dialog-content {
    min-height: 120px;
  }
</style>